export const OTP_CODE_LENGTH = 4;

export enum OtpErrors {
  CODE_EXPIRED = 'sms_auth_code_expired',
  CODE_MANY_ATTEMPTS = 'sms_auth_code_many_attempts',
  CODE_INVALID = 'sms_auth_code_invalid',
  CODE_NOT_SEND = 'sms_auth_sms_not_sent',
}
